// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__1AdQC","date":"CreditCardExpiryDate_date__q71sT"};